module.exports = __webpack_public_path__ + "media/images/wellbeing-logo-0c79f8b60db35c699cc29685a6585e76.png";